import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { selectDatasourceId } from '@/redux/session/selectors';
import { selectSidebarMeta } from '@/redux/sidebar/selectors';

export const useExternalSourceDatasourceId = (): string | null => {
  const { datasourceId: fromParams } = useParams();
  const fromSelection = useSelector(selectDatasourceId);
  const isCreateIntent = useSelector(selectSidebarMeta)?.mode === 'create';

  return (isCreateIntent ? null : fromParams || fromSelection) ?? null;
};
